/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const UserImage = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 2.5rem;
  border: 3px solid ${theme.color.border.border01};
`;

export const FeedbackButton = styled.div`
  position: fixed;
  right: 0;
  bottom: 1rem;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;
